import { NgOptimizedImage, registerLocaleData } from "@angular/common";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import en from "@angular/common/locales/en";
import { ErrorHandler, NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { IconDefinition } from "@ant-design/icons-angular";
import * as AllIcons from "@ant-design/icons-angular/icons";
import { GlobalErrorHandler } from "app/_shared/interceptor/error.interceptor";
import { HeaderInterceptor } from "app/_shared/interceptor/header.interceptor";

import { NgZorroModule } from "app/_shared/ng-zorro.module";
import { SharedModule } from "app/_shared/shared.module";
import { autoTips } from "app/_shared/utils/form.utils";

import { NZ_CONFIG, NzConfig } from "ng-zorro-antd/core/config";
import { en_US, NZ_I18N } from "ng-zorro-antd/i18n";
import { NzIconModule } from "ng-zorro-antd/icon";

import { NgProgressModule } from "ngx-progressbar";
import { NgProgressRouterModule } from "ngx-progressbar/router";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

import { BlankComponent } from "./layouts/blank/blank.component";
import { FullComponent } from "./layouts/full/full.component";

import { MsalModule, MsalService, MsalBroadcastService } from "@azure/msal-angular";
import { PublicClientApplication, BrowserCacheLocation } from "@azure/msal-browser";

const antDesignIcons = AllIcons as {
  [key: string]: IconDefinition;
};
const icons: IconDefinition[] = Object.keys(antDesignIcons).map((key) => antDesignIcons[key]);

// The Factory function
const ngZorroConfig: NzConfig = { form: { nzAutoTips: autoTips } };

registerLocaleData(en);

@NgModule({
  declarations: [AppComponent, BlankComponent, FullComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    BrowserAnimationsModule,
    NzIconModule.forRoot(icons),
    NgZorroModule,
    SharedModule,
    NgOptimizedImage,
    NgProgressModule,
    NgProgressRouterModule,
    MsalModule.forRoot(
      new PublicClientApplication({
        auth: {
          clientId: "a1b170fd-fd1a-47c5-8f12-2b720ca0562f", // Replace with your Azure AD application (client) ID
          authority: "https://login.microsoftonline.com/common", // Or your tenant ID
          redirectUri: window.location.origin, // Your redirect URI
        },
        cache: {
          cacheLocation: BrowserCacheLocation.LocalStorage,
          storeAuthStateInCookie: true, // set to true for IE 11
        },
      }),
      null,
      null,
    ),
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    { provide: NZ_I18N, useValue: en_US },
    { provide: NZ_CONFIG, useValue: ngZorroConfig },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptor, multi: true },
    MsalService,
    MsalBroadcastService,
  ],
})
export class AppModule {}
